module.exports = __webpack_public_path__ + "img/yuan2.b6403610.png";